import React from "react";
import "./deliveryMethod.css";
import "../../../Shared/Style/addOrEditDeliveryMethod.css";
import { Button } from "react-bootstrap";
import Validation from "../../../Shared/Validation";
import SecurityVerificationPopUp from "./securityVerificationPopUp"
import { NotificationManager } from 'react-notifications';
import Modal from "react-modal";
import { isMobile } from '../../../helpers/utils';
import './mobileStyle.css';

class EmailComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVerificationnModal: false
    }
    this.textInput = React.createRef();
  }
  validateEmail(email) {
    const pattern = /^[a-zA-Z0-9.!#$%&*+\/=?^_`{|}~;-]{1,64}[@][a-zA-Z0-9-.]{1,255}$/g;
    const result = pattern.test(email);
    return result;
  }

  renderVerification = () => {
    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '65%',
        minWidth: '65%'
      }
    };

    return (<Modal
      style={customStyles}
      ariaHideApp={false}
      isOpen={this.state.showVerificationnModal}
      onRequestClose={() => {
        this.setState({ showVerificationnModal: false, currentItem: {} });
      }}
      contentLabel="Email Verification Modal"
    >
      <SecurityVerificationPopUp
        onCancel={() => {
          this.setState({ showVerificationnModal: false, currentItem: {} });

          this.props.updateBankingAlertValues({
            currentEditItemId: "",
            currentEditItemType: "",
            currentEditItemValue: ""
          });
          this.props.addBankingAlertValue({
            currentAddItemType: "",
            currentAddItemValue: ""
          });

        }}
        resendCode={() => {

          const currentItem = this.state.currentItem;
          this.props.triggerVerificationCode(
            {
              address: this.props.deliveryEditItem
              .currentEditItemValue || currentItem.address,
              id: this.props.deliveryEditItem.currentEditItemId || currentItem.id,
            },
            "Email"
          );
        }}
        onSubmit={code => {
          const currentItem = this.state.currentItem;
          this.props.submitVerificationCode(
            {
              address: this.props.deliveryEditItem
                .currentEditItemValue || currentItem.address,
              verificationCode: code,
              id: this.props.deliveryEditItem.currentEditItemId || currentItem.id,
              verifiedBy: "NotificationCenter"
            },
            "Email"
          ).then((res) => {
            if(res){
              var alertEmailId = document.getElementById('showEmailAlert');
              var alertTextId = document.getElementById('showTextAlert');
              alertEmailId.style.display = 'block';
              alertTextId.style.display = 'none';
              alertEmailId.innerHTML = 'Verified successfully';
              alertEmailId.classList.add("alignAlert");

            this.setState({ showVerificationnModal: false, currentItem: {} });
            this.props.updateBankingAlertValues({
              currentEditItemId: "",
              currentEditItemType: "",
              currentEditItemValue: ""
            });
            this.props.addBankingAlertValue({
              currentAddItemType: "",
              currentAddItemValue: ""
            });
          }
          });

        }}
      ></SecurityVerificationPopUp>
    </Modal>);
  }

  render() {
    const {
      deliveryAddItem: {
        currentAddItemType
      },
      deliveryEditItem: {
        currentEditItemType,
        currentEditItemId
      },
      history
    } = this.props;
    const addDisabled = currentAddItemType !== "Email" && currentAddItemType !== "";
    const disabled = currentEditItemType !== "Email" && currentEditItemType !== "";
    
    var emailAddresses = this.props.items.filter(element => element.channel === 'Email');
    
    var buttonText = "Add Email Address";

    if (emailAddresses.length > 9)  buttonText = "Maximum number of email addresses has been reached. Please remove an email address before another can be added.";
    const maxEmailsAdded = (emailAddresses.length > 9);


    const newEmail = isMobile() && !maxEmailsAdded ?
      (<a

        tabIndex={0}
        className="AppLink mobile"
        href={`#/emailOrPhoneEdit/email`}>
        Add Email Address
      </a>) :
      (<Button
        variant="Link"
        tabIndex={0}
        className="AppLink desktop align-content-items-for-delivery-method-mobile"
        id="addemail"
        onClick={() => {
          this.props.updateBankingAlertValues({
            currentEditItemId: "",
            currentEditItemType: "",
            currentEditItemValue: "",
            isValid: false
          });
          this.props.addBankingAlertValue({
            currentAddItemType: "Email",
            currentAddItemValue: "",
            isValid: false
          });
        }}
        disabled={disabled ||
          addDisabled || currentEditItemType === "Email" || maxEmailsAdded}
      >
        {buttonText}
      </Button>)
      
    return (
      <div
        id="dvEmailsection"
        className={`comp-category-container-addEdit ` + (
          disabled ||
            addDisabled ? `disabled-dm` : ``)}
      >
        <h3 className={isMobile() ? `mobile-font-family mobile-category ` : `email-category`} id="emailText">
          {this.props.name}
        </h3>
        <div className="hr-addEdit-deliveryMethod" />
        
        {/* Alert for Low vision users */}
        <div id="showEmailAlert" >
        </div> 

        {this.props.items.map((item, key) => {
          const itemDisabled = currentEditItemType === "Email" && currentEditItemId !== item.id;

          const addItemDisabled = currentAddItemType === "Email";
          const Edit = (isMobile() && currentEditItemId === '') ?
            (<Button variant="Link"
              disabled={disabled ||
                addDisabled || itemDisabled || addItemDisabled}
              aria-label={`Edit for email address ` + item.address}
              tabIndex={0}
              className="AppLink mobile-font-family mobile-edit-item padding-unset padding-left"
              href={`#/emailOrPhoneEdit/${item.id}/email`}>
              Edit
            </Button>) :
            (
              <Button variant="Link"
                aria-label={`Edit for email address ` + item.address}
                aria-live={`polite`}
                tabIndex={0}
                className="AppLink edit-item padding-unset padding-left"
                disabled={disabled ||
                  addDisabled || itemDisabled || addItemDisabled}
                onClick={() => {

                  
                  this.props.updateBankingAlertValues({
                    currentEditItemId: item.id,
                    currentEditItemType: "Email",
                    currentEditItemValue: item.address,
                    isValid: this.validateEmail(item.address)
                  });
                  setTimeout(() => {
                    if (this.textInput.current) {
                      this.textInput.current.focus();
                    }
                  }, 1000)

                }}
                role="button"
                name="edit"

                id={`emailEditLink` + key}
              >
                Edit
              </Button>
            );
          const verify = (
            <Button
              aria-label={`Verify email address for ` + item.address + '. email address '+ item.addres + '  is not verified .'}
              variant="Link" tabIndex={0}
              disabled={disabled ||
                addDisabled || itemDisabled || addItemDisabled}
              className={
                isMobile() ?
                  `mobile-font-family AppLink dividerColor mobile-edit-item padding-unset padding-right`
                  :
                  `AppLink dividerColor edit-item padding-unset padding-right`}
              onClick={() => {
                this.props.triggerVerificationCode(
                  {
                    address: item.address,
                    id: item.id
                  },
                  "DeliveryMethods"
                ).then(res => {


                  if (res) {
                    if (isMobile()) {
                      this.props.addCurrentOperatingValue(item.address)
                      history.push(`/verifyEmailOrPhone/email/` + item.id)

                    }
                    else {
                      this.setState({ showVerificationnModal: true, currentItem: item });
                    }
                  }
                })

              }}

            >
              Verify
    </Button>

          );

          return (
            <div key={key} className=
              {(itemDisabled ? `disabled-dm` : ``) +
                (addItemDisabled ? `disabled-dm` : ``) + ` email-align-content`}>
              {this.props.deliveryEditItem.currentEditItemId !== item.id ? (
                <div className={`displayFlex`}>
                  <div className={`flex1`}>
                    <label 
                    // aria-describedby={`${this.props.name}` + key}
                      id={"EmailListItem" + item.id}
                      className={
                        isMobile() ?
                          `mobile-font-family mobile-align-content-items-for-delivery-method`
                          :
                          `align-content-items-for-delivery-method padding-unset padding-left`}
                    >
                      {item.address}
                    </label>
                    {!item.isVerified && (
                      <Validation
                        message={`${this.props.name} not verified`}
                        messageId={`${this.props.name}` + key}
                        className="align-validation-message"
                      />
                    )}
                  </div>
                  <div className="padding-top-button">
                    {!item.isVerified && (verify)}
                  </div>
                  <div className="padding-top-button">
                    {Edit}
                    <span className="sr-only">{`Edit button for email address ` + item.address}</span>
                  </div>


                </div>
              ) : (
                  <div className="comp-category-container-addEdit displayFlex justify-content spacing padding-top">
                    <div>
                      <input
                        tabIndex={0}
                        type="text"
                        value={this.props.deliveryEditItem.currentEditItemValue}
                        onChange={event => {
                          this.props.updateBankingAlertValues({
                            currentEditItemValue: event.target.value,
                            isValid: this.validateEmail(event.target.value)
                          });
                        }}
                        ref={this.textInput}
                        className={`bg-light text-dark form-control ${this.props.deliveryEditItem.isValid ? 'is-valid' : 'is-invalid'}`}
                      />
                      {!this.props.deliveryEditItem.isValid && <div className="invalid-feedback"> Invalid email address</div>}
                    </div>
                    <div className="alignbuttons">
                    <Button
                    id="savebutton"
                        aria-label={`Save and Verify for email address` + item.address}
                        className=" alignColor left-margin "
                        onClick={() => {

                          if(!this.props.deliveryEditItem.isValid)  { NotificationManager.error("Invalid email");
                            return;
                          }else if (  item.address === this.props.deliveryEditItem.currentEditItemValue){
                            NotificationManager.error(" email not changed ");
                            return;
                          }
                          this.props.saveAndVerifyDeliveryMethod({
                            address: this.props.deliveryEditItem.currentEditItemValue,
                            id: this.props.deliveryEditItem.currentEditItemId,
                            deliveryChannel: "Email"
                          }).then(response => {
                            if (response) {
                              var alertEmailId = document.getElementById('showEmailAlert');
                              var alertTextId = document.getElementById('showTextAlert');
                              alertEmailId.style.display = 'block';
                              alertTextId.style.display = 'none';
                              alertEmailId.innerHTML = 'Updated successfully';
                              alertEmailId.classList.add("alignAlert");
                              this.props.updateBankingAlertValues({
                                currentEditItemId: "",
                                currentEditItemType: "",
                                currentEditItemValue: ""
                              });
                              this.setState({
                                showVerificationnModal: true,
                                currentItem: response
                              })
                            }
                          });
                        }}
                      >
                        {this.props.buttontext}
                      </Button>
                      <Button
                      
                        aria-label={`Cancel Editing for email address ` + item.address}                        
                        className="aligncancelbuttoncolor left-margin "
                        onClick={() => {
                          this.props.updateBankingAlertValues({
                            currentEditItemId: "",
                            currentEditItemType: "",
                            currentEditItemValue: ""
                          });
                        }}
                      >
                        Cancel
                     </Button>
                      <Button
                        aria-label={`Delete for email address ` + item.address}
                        variant="Link"
                        className="AppLink"
                        onClick={() => {
                          this.props.showDeleteConfirmation(
                            "Are you sure you want to delete " + item.address,
                            () => {
                              var alertEmailId = document.getElementById('showEmailAlert');
                              var alertTextId = document.getElementById('showTextAlert');
                              alertEmailId.style.display = 'block';
                              alertTextId.style.display = 'none';
                              alertEmailId.innerHTML = 'Email address deleted successfully';
                              alertEmailId.classList.add("alignAlert");
                              this.props.deleteDeliveryAddress({
                                id: item.id,
                              });
                            }
                          );
                        }}
                      >
                        Delete
                     </Button>
                     
                    </div>
                  </div>
                )}
            </div>
          );
        })}
        <div className={(this.props.deliveryEditItem.currentEditItemType === "Email" ? "disabled-dm" : "")}>
          <div>

            {(this.props.deliveryAddItem.currentAddItemType === "" || this.props.deliveryAddItem.currentAddItemType !== "Email") &&
              <div className={isMobile() ? `mobile-font-family add-new-item-mobile` : `add-new-item`}>
                {this.props.items.length === 0 && <div className={isMobile() ? `padding-top italic` : `spacing padding-top italic`}>No Email Address found</div>}
                {newEmail}
              </div>
            }
            {this.props.deliveryAddItem.currentAddItemType === "Email" && (
              <div className="containerForAddingDeliveryMethod ">

                <div className="hr-add-edit-deliveryMethod" />
                <div className="comp-category-container-addEdit displayFlex justify-content spacing">
                  <div>
                    <label aria-label="input-text">
                      <input
                        maxLength='320'
                        type="text" placeholder="Email"
                        id="deliveryMethodTextBox"
                        className={`bg-light text-dark form-control ${this.props.deliveryAddItem.isValid ? 'is-valid' : 'is-invalid'}`}
                        onChange={event => {
                          this.props.addBankingAlertValue({
                            currentAddItemValue: event.target.value,
                            isValid: this.validateEmail(event.target.value)
                          });
                        }}
                      />
                    </label>
                    {!this.props.deliveryAddItem.isValid && <div className="invalid-feedback show"> Invalid email address</div>}
                  </div>
                  <div className="flex1">
                    <Validation
                      message={`${this.props.name} not verified`}
                      messageId={`${this.props.name}id`}
                    />
                  </div>

                  <div className="alignbuttons">
                  <Button 
                  id="savebutton"
                  className=" alignColor "
                     //if {!this.props.deliveryAddItem.isValid}
                      onClick={() => {  
                        if(!this.props.deliveryAddItem.isValid)  { NotificationManager.error("Invalid email");
                        return;
                      }else {
                        this.props.addDeliveryMethod({
                          address: this.props.deliveryAddItem
                            .currentAddItemValue,
                          "deliveryChannel": "email",
                          "nickname": "",
                          "type": "email",
                        }).then(response => {
                          if (response) {
                            var alertEmailId = document.getElementById('showEmailAlert');
                            var alertTextId = document.getElementById('showTextAlert');
                              alertEmailId.style.display = 'block';
                              alertTextId.style.display = 'none';
                              alertEmailId.innerHTML = 'Email address created successfully';
                              alertEmailId.classList.add("alignAlert");
                            this.setState({ showaddcomponent: false });
                            this.props.addBankingAlertValue({
                              currentAddItemType: "",
                              currentAddItemValue: ""
                            });                        
                            this.setState({
                              showVerificationnModal: true,
                              currentItem: response
                            })
                          }
                        });
                      }
                      }}>

                      {this.props.buttontext}
                      
                    </Button>

                    <Button
                      aria-label={`cancel add email address`}
                      className="aligncancelbuttoncolor left-margin "
                      onClick={() => {
                        this.setState({ showaddcomponent: false });
                        this.props.addBankingAlertValue({
                          currentAddItemType: "",
                          currentAddItemValue: ""
                        });

                      }}
                    >
                      Cancel
                    </Button>
                    

                  </div>
                </div>
                <div className="hr-add-edit-deliveryMethod" />
              </div>
            )}
          </div>
        </div>

        {this.renderVerification()}
        <div className="hr-addEdit-deliveryMethod" />
      </div>
    );
  }
}
export default EmailComponent;
